import React, { useEffect, useMemo, useState } from "react";
import HeadOrderDetails from "./SharedModule/HeadOrderDetails";
import { useNavigate, useParams } from "react-router-dom";
import SideOrderDetails from "./SharedModule/SideOrderDetails";
import NotFound from "./SharedModule/NotFound";
import axios from "axios";
import note from '../../src/assets/images/comments.png'
import { useSelector } from "react-redux";
import './OrderReviews.css'

export default function OrderReviews() {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const baseUrl = "https://estbn.com/EstbnNew/public";

  const [reviews, setReviews] = useState([]);

  const { id } = useParams();

  const getReviews = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/portal/order-reviews/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(response.data.data.reviews);
      setReviews(response.data.data.reviews);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const goToOrderDetails = () => {
    navigate(`/orders/${id}`);
  };

  const goToActivityDetails = () => {
    navigate(`/Activity/${id}`);
  };

  const goToComments = () => {
    navigate(`/comments/${id}`);
  };
    
  const goToCheckBefore = () => {
    navigate(`/checkBefore/${id}`);
  };

  const goToCheckAfter = () => {
    navigate(`/checkAfter/${id}`);
  };

  useEffect(() => {
    getReviews();
  }, [])

  //////////////////////////////

  const ENTITY_TYPES = {
    'App\\Models\\User': 'customer',
    'App\\Contexts\\Workforce\\Models\\Staff': 'staff',
    'App\\Contexts\\Order\\Models\\DoorStepOrder': 'order',
  };
  
  
  const RELATION_CONFIG = {
    'customer-order': { tab: 'Client To Order', short: 'Rated the order', color: '#3FBEAC' },
    'customer-staff': { tab: 'Client To Staff', short: 'Rated the Staff', color: '#3E9FF6' },
    'staff-staff': { tab: 'Staff To Staff ', short: 'Rated Staff', color: '#7E1BAD' },
    'staff-customer': { tab: 'Staff To Client ', short: 'Rated the Client', color: '#FEB91E' },
  };
  
  const FALLBACK_RELATION = { tab: 'Other', short: 'Rated', color: 'gray' };
  
  const getKind = (type) => ENTITY_TYPES[type]
  
  const getEntityName = (entity, kind) => {
    if (!entity) return '—';
    if (kind === 'order') {
      return entity.reference || entity.order_number || `Order #${entity.id}`;
    }
    if (kind === 'customer') return entity.name || '—';
    if (kind === 'staff') {
      return [entity.first_name, entity.last_name].filter(Boolean).join(' ') || '—';
    }
    return '—';
  };
  
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    return parts.length === 1 ? parts[0].slice(0, 1) : parts[0].slice(0, 1) + parts[1].slice(0, 1);
  };
  
  const getReasonList = (review) => {
    const titles = review.reason_titles;
    if (!titles || Array.isArray(titles)) return [];
    return Object.values(titles);
  };
  
  const formatDate = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };
  
  function OrderIcon() {
    return (
      <svg viewBox="0 0 24 24" className="rv-order-icon" aria-hidden="true">
        <path
          d="M6 3h8l4 4v14H6V3z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path d="M14 3v4h4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M9 12h6M9 16h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    );
  }
  
  function Avatar({ name, photoUrl, kind, size = 'md' }) {
    const [failed, setFailed] = useState(false);
  
    if (kind === 'order') {
      return (
        <span className={`rv-avatar rv-avatar--${size} rv-avatar--order`} title={name}>
          <OrderIcon />
        </span>
      );
    }
  
    if (photoUrl && !failed) {
      return (
        <img
          src={photoUrl}
          alt={name}
          className={`rv-avatar rv-avatar--${size} rv-avatar--photo`}
          onError={() => setFailed(true)}
        />
      );
    }
  
    return (
      <span className={`rv-avatar rv-avatar--${size} rv-avatar--${kind}`}>
        {getInitials(name)}
      </span>
    );
  }
  
  function StarRating({ value }) {
    return (
      <div className="rv-stars" aria-label={`${value} out of 5 stars`}>
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n} className={`rv-star ${n <= value ? 'is-filled' : ''}`}>★</span>
        ))}
      </div>
    );
  }
  
  function ReasonChips({ reasons, rating }) {
    if (!reasons.length) return null;
    return (
      <ul className="rv-reasons my-1">
        {reasons.map((reason, i) => (
          <li style={{color: rating >= 3 ? "#3FBEAC" : "#A80101",
            backgroundColor:  rating >= 3 ? "#ECF9F7" : "#FFF4F0",
            border: rating >= 3 ? "1px solid #3FBEAC" :"1px solid #A80101"
          }} key={i} className="rv-chip px-2 py-1">{reason}</li>
        ))}
      </ul>
    );
  }
  
  function ReviewCard({ review, baseUrl }) {
    const reviewerKind = getKind(review.reviewable_type);
    const reviewedKind = getKind(review.reviewed_type);
    const reviewerName = getEntityName(review.reviewable, reviewerKind);
    const reviewedName = getEntityName(review.reviewed, reviewedKind);
  
    const reviewerPhoto = review.reviewable?.profile_photo_path
      ? `${baseUrl}${review.reviewable.profile_photo_path}`
      : null;
  
    const relation = RELATION_CONFIG[`${reviewerKind}-${reviewedKind}`] || FALLBACK_RELATION;
    const reasons = getReasonList(review);
  
    const subtitle =
      reviewedKind === 'order' ? relation.short : `${relation.short} · ${reviewedName}`;
  
    return (
      <article className="rv-card">
        <div className="rv-card__header">
          <div className="rv-who">
            <Avatar name={reviewerName} photoUrl={reviewerPhoto} kind={reviewerKind} />
            <div className="rv-who__text">
              <span className="rv-who__name">{reviewerName}</span>
              <StarRating value={review.rating} />
              <span className="rv-subtitle">
                <span className={`rv-dot rv-dot--${relation.color}`} />
                {subtitle}
              </span>
            </div>
          </div>
          <time className="rv-date" dateTime={review.created_at}>
            {formatDate(review.created_at)}
          </time>
        </div>
  
        {review.comment && <p className="rv-comment">{review.comment}</p>}
  
        <ReasonChips reasons={reasons} rating={review.rating} />
      </article>
    );
  }
  

    const [activeFilter, setActiveFilter] = useState('all');
  
    const counts = useMemo(() => {
      const acc = {};
      reviews.forEach((review) => {
        const key = `${getKind(review.reviewable_type)}-${getKind(review.reviewed_type)}`;
        acc[key] = (acc[key] || 0) + 1;
      });
      return acc;
    }, [reviews]);
  
    const tabs = useMemo(
      () =>
        Object.keys(counts)
          .filter((key) => RELATION_CONFIG[key])
          .map((key) => ({ key, ...RELATION_CONFIG[key], count: counts[key] })),
      [counts]
    );
  
    const visibleReviews = useMemo(() => {
      if (activeFilter === 'all') return reviews;
      return reviews.filter(
        (review) => `${getKind(review.reviewable_type)}-${getKind(review.reviewed_type)}` === activeFilter
      );
    }, [reviews, activeFilter]);

  return (
    <>
      {/* Head Details */}
      <HeadOrderDetails />
      {/* Details Filteration */}
      <div className="details-filter mx-4">
        <button onClick={goToOrderDetails} className="btn">
          Order Details
        </button>
        <button onClick={goToActivityDetails} className="btn ">
          Activity logs
        </button>
        <button onClick={goToComments} className="btn ">
          Client Comments
        </button>
        {user.operator.roles[0].name === "outbound-agent" ? (
          ""
        ) : (
          <>
            <button className="btn" onClick={goToCheckBefore}>
              Check Body Before
            </button>
            <button className="btn" onClick={goToCheckAfter}>
              Check Body After
            </button>
          </>
        )}
        <button className="btn bg-black text-white">Reviews</button>
      </div>
      {/* Comments Details  */}
      <div className=" Comments Details">
        <div className="row m-4 justify-content-between">
          <div className="col-sm-12 col-md-8 border border-1 rounded-2">
        
            {/* comments */}
            {reviews && reviews.length > 0 ? (
          
                 <div className="rv-wrapper">
      <h2 className="rv-title">Order Reviews</h2>

      {tabs.length > 1 && (
        <div className="rv-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={activeFilter === 'all'}
            className={`rv-tab ${activeFilter === 'all' ? 'is-active' : ''}`}
            onClick={() => setActiveFilter('all')}
          >
            All <span className="rv-tab__count">({reviews.length})</span>
          </button>
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeFilter === tab.key}
              className={`rv-tab ${activeFilter === tab.key ? 'is-active' : ''}`}
              onClick={() => setActiveFilter(tab.key)}
            >
              {tab.tab} <span className="rv-tab__count">({tab.count})</span>
            </button>
          ))}
        </div>
      )}

      {visibleReviews.length ? (
        <div className="rv-list">
          {visibleReviews.map((review) => (
            <ReviewCard key={review.id} review={review} baseUrl={baseUrl} />
          ))}
        </div>
      ) : (
        <div className="rv-empty">
          <p>No reviews recorded for this order yet.</p>
        </div>
      )}
    </div>
            ) : (
              <NotFound
                paragraphText={
                  "No Reviews yet. All your Reviews will appear here once you get started."
                }
              />
            )}
          </div>
          {/* SideOrderDetails  */}
          <SideOrderDetails />
        </div>
      </div>
    </>
  );
}
